import { Component } from 'react';
import { translate } from 'react-i18next';

// Services
import { updateInvoiceCertificate } from 'src/views/practitioner/Appointment/reducers/invoices';

// Components
import CustomModal from 'components/CustomModal/index';
import InputCertificateNumber from '../InputCertificateNumber/index';

// Styles
import * as modalStyles from 'components/CustomModal/styles';

class CertificateModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      certificateNumber: null,
      errorMessage: null
    };
    this.setCertificateNumber = this.setCertificateNumber.bind(this);
    this.onChangeCertificateNumber = this.onChangeCertificateNumber.bind(this);
    this.onUpdateCertificate = this.onUpdateCertificate.bind(this);
  }

  componentDidMount() {
    this.setCertificateNumber();
  }

  componentDidUpdate(prevProps) {
    const {
      invoice: { certificateNumber, maxCertificateNumber }
    } = this.props;
    if (
      prevProps &&
      prevProps.invoice &&
      (certificateNumber !== prevProps.invoice.certificateNumber ||
        maxCertificateNumber !== prevProps.invoice.maxCertificateNumber)
    ) {
      this.setCertificateNumber();
    }
  }

  setCertificateNumber() {
    const {
      invoice: { certificateNumber, maxCertificateNumber }
    } = this.props;
    const certNumber =
      (certificateNumber && Number(certificateNumber)) ||
      (maxCertificateNumber && Number(maxCertificateNumber)) ||
      0;
    this.setState({ certificateNumber: certNumber });
  }

  onChangeCertificateNumber(value) {
    this.setState({ certificateNumber: value, errorMessage: null });
  }

  onUpdateCertificate() {
    const { certificateNumber } = this.state;
    const { closeModal, invoice } = this.props;
    updateInvoiceCertificate(invoice, certificateNumber).then(
      () => {
        closeModal();
      },
      errMessage => {
        this.setState({ errorMessage: errMessage });
      }
    );
  }

  render() {
    const { isOpen, closeModal, i18n } = this.props;
    const { certificateNumber, errorMessage } = this.state;

    return (
      <CustomModal
        isOpen={isOpen}
        onRequestClose={closeModal}
        style={{ content: { maxWidth: '30em', padding: 0 } }}
      >
        <modalStyles.CommonModalWrapper>
          {/* ──── Header ───────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection className="header-wrapper">
            <modalStyles.ModalCloseIcon className="close-icon" onClick={closeModal} />
            <modalStyles.ModalTitle>
              {i18n.t('certificate_number_modal_title')}
            </modalStyles.ModalTitle>
          </modalStyles.ModalBlockSection>

          {/* ──── Content ───────────────────────────────────────────────────────────────────── */}
          <modalStyles.ModalBlockSection style={{ marginBottom: '.3em' }}>
            <InputCertificateNumber
              error={errorMessage}
              maxCertificateNumber={certificateNumber}
              onChangeCertificate={this.onChangeCertificateNumber}
            />
            {errorMessage && <span className="error-message">{i18n.t(errorMessage)}</span>}
          </modalStyles.ModalBlockSection>

          {/* ──── Footer ────────────────────────────────────────────────────────────────────── */}

          <modalStyles.ModalFooter className="footer" topBorder>
            <modalStyles.ModalCancel onClick={closeModal}>
              {i18n.t('cancel')}
            </modalStyles.ModalCancel>

            <modalStyles.ModalFooterBtn
              style={{ minWidth: '140px' }}
              disabled={errorMessage}
              onClick={this.onUpdateCertificate}
            >
              {i18n.t('save')}
            </modalStyles.ModalFooterBtn>
          </modalStyles.ModalFooter>
        </modalStyles.CommonModalWrapper>
      </CustomModal>
    );
  }
}

export default translate()(CertificateModal);
